/**
 * Flatten a DRF error body into one readable line.
 *
 * Handles the three DRF shapes: a list of messages, a field->messages map
 * (field names prefixed for context), and `{detail: "..."}`.
 */
export function formatApiError(
  data: unknown,
  fallback = "Request failed.",
): string {
  if (Array.isArray(data)) return data.join(" ");
  if (data && typeof data === "object") {
    const entries = Object.entries(data as Record<string, unknown>);
    if (!entries.length) return fallback;
    return entries
      .map(([field, messages]) => {
        const text = Array.isArray(messages)
          ? messages.join(" ")
          : String(messages);
        return field === "detail" || field === "non_field_errors"
          ? text
          : `${field}: ${text}`;
      })
      .join(" | ");
  }
  return fallback;
}
